import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sitemap2',
  templateUrl: './sitemap2.component.html',
  styleUrls: ['./sitemap2.component.scss']
})
export class Sitemap2Component implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  

  constructor() { }

  ngOnInit() {
  }

}
